import { render, staticRenderFns } from "./ChannelSelectItem.vue?vue&type=template&id=c06ca7dc&scoped=true&"
import script from "./ChannelSelectItem.vue?vue&type=script&lang=js&"
export * from "./ChannelSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSelectItem.vue?vue&type=style&index=0&id=c06ca7dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06ca7dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib'
installComponents(component, {VRow})
